import React from 'react'
import { motion } from 'framer-motion' // Import Motion
import Digital from '../../assets/responsive.jpg';
import Strategy from '../../assets/ux.jpg';
import Tools from '../../assets/infr.jpg';

const Design = () => {
    // Parent container animation logic
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3, // Delay between each card
                duration: 2 // Total section fade duration
            }
        }
    };

    // Individual item animation logic
    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { 
            opacity: 1, 
            y: 0, 
            transition: { duration: 2, ease: "easeOut" } // 2 second duration as requested
        }
    };

    return (
        <section className="toolkit">
            <motion.div 
                className="container h"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.2 }}
                variants={containerVariants}
            >
                <motion.h2 className="h2-dark center" variants={itemVariants}>
                    Digital Architecture & Design
                </motion.h2>
                <div className="divider">
                    <div className="v-primary vider"></div>
                    <div className="v-dark vider"></div>
                    <div className="v-primary vider"></div>
                </div>
                <div className="wrapper shadow">
                    <div className="description">
                        
                        <div className="cards">
                            <motion.div className="card" variants={itemVariants}>
                                <div className="card-image-container">
                                    <img src={Digital} alt='Digital design' className='card-image'/>
                                </div>
                                <h3 className="card-head-dark">
                                    Web Development: 
                                </h3>
                                <div className="description">
                                    <p className="card-text-dark">
                                        Crafting responsive layouts and interactive user experiences using 
                                        HTML5, CSS3, and JavaScript (ReactJS).
                                    </p>
                                </div>
                            </motion.div>

                            <motion.div className="card" variants={itemVariants}>
                                <div className="card-image-container">
                                    <img src={Tools} alt='Technical engineering' className='card-image'/>
                                </div>
                                <h3 className="card-head-dark">
                                    Visual Strategy: 
                                </h3>
                                <div className="description">
                                    <p className="card-text-dark">
                                        Professional digital branding and logo design via Canva, Photopea, and Photoshop.
                                    </p>
                                </div>
                            </motion.div>

                            <motion.div className="card" variants={itemVariants}>
                                <div className="card-image-container">
                                    <img src={Strategy} alt='Digital design' className='card-image'/>
                                </div>
                                <h3 className="card-head-dark">
                                    Infrastructure: 
                                </h3>
                                <div className="description">
                                    <p className="card-text-dark">
                                        Building accessible, high-speed user experiences with a focus on clean code.
                                    </p>
                                </div>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </motion.div>
            <div className="space"></div>
        </section>
    )
}

export default Design